import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { sendToGTM } from '../context/utils/GoogleTagManager';
import { getSectionCategorySubCat } from '../getSectionCategorySubCat';
export var ecommViewCart = function ecommViewCart(product) {
  var _product$items;

  var ecommerceObj = {
    event: 'view_cart',
    detailed_event: 'View Cart',
    ecommerce: {
      currency: 'USD',
      items: (product === null || product === void 0 ? void 0 : (_product$items = product.items) === null || _product$items === void 0 ? void 0 : _product$items.map(function (item) {
        var categories = getSectionCategorySubCat(item === null || item === void 0 ? void 0 : item.detailLink);
        item === null || item === void 0 ? true : delete item.detailLink;
        return _objectSpread(_objectSpread({}, item), {}, {
          item_category: categories[0],
          item_category2: categories[1],
          item_category3: categories[2],
          item_category4: categories[3],
          item_category5: categories[4]
        });
      })) || [],
      value: (product === null || product === void 0 ? void 0 : product.value) || 0
    }
  }; // Clear out the ecomm object first

  sendToGTM({
    data: {
      ecommerce: null
    }
  });
  sendToGTM({
    data: ecommerceObj
  });
};